import { createEvent, restore, sample } from 'effector'
import { createInfiniteList, fx } from '../../../../../libs'
import {
  RangeValue,
  TransactionsDetailsRequest,
  TransactionsDetailsResponse,
} from './types'
import { $params } from '../../../../../features/router'
import { changedDateFormat } from '../../../../../libs/utils'
import { getCurrencies } from '../../../wallets/details/model'

import { WalletResponse } from 'src/views/widgets/walletCard/types'

export const transactionsDetailsMounted =
  createEvent<TransactionsDetailsRequest>()

export const loadWalletsWithArchive = createEvent()

export const getTransactionsDetails = fx<void, TransactionsDetailsResponse>({
  method: 'GET',
  url: '/finance/all_transaction',
})

const allTransactions = createInfiniteList(getTransactionsDetails)

export const $transactionsDetails = allTransactions.$items
export const $totalCountOfTransactionsDetail = allTransactions.$total
export const $loadedPageOfTransactionsDetail = allTransactions.$loadedPage
export const $hasMoreTransactionsDetail = allTransactions.$hasMore

export const getWalletsWithArchiveFx = fx<void, WalletResponse>({
  method: 'GET',
  url: `/finance/wallet`,
  query: { where: JSON.stringify({ includeArchived: true }), order: 'name'},
})

export const $optionsWallet = restore<{text:string, value: string}[]>(
  getWalletsWithArchiveFx.doneData.map((a) => {
    return a.body.items.map(({name, id})=> ({text: name, value: id}))
  }),
  [],
)

sample({
  clock: transactionsDetailsMounted,
  filter: ({ page }) => !page || page <= 1,
  fn: () => {
    let query = {
      order: 'code',
    }
    return {
      query,
    }
  },
  target: getCurrencies,
})
// sample({
//   // @ts-ignore
//   clock: transactionsDetailsMounted,
//   fn: () => {
//     let query = {
//       order: 'name',
//     }

//     return {
//       query,
//     }
//   },
//   target: getWallets,
// })
sample({
  // @ts-ignore
  clock: transactionsDetailsMounted,
  source: $params,
  fn: (
    params,
    { limit, page, searchText, filters, orderBy, orderDirection },
  ) => {
    let filtersTransactionsParams = {}

    let query = {
      limit,
      page,
    }

    if (orderBy && orderDirection) {
      // @ts-ignore
      query['order'] = `${orderDirection === 'asc' ? '' : '-'}${orderBy}`
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      filtersTransactionsParams = Object.keys(filters).reduce(
        (accumulator, key) => {
          if (filters[key as keyof typeof filters] != null) {
            if (key === 'currency' || key === 'wallets' || key === 'type') {
              accumulator[key as keyof typeof filters] =
                filters[key as keyof typeof filters]
            } else if (key === 'period') {
              if ((filters[key as keyof typeof filters] as RangeValue)[0]) {
                accumulator['dateFrom'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[0].$d,
                )
              }
              if ((filters[key as keyof typeof filters] as RangeValue)[1]) {
                accumulator['dateTo'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[1].$d,
                )
              }
            } else {
              accumulator[key as keyof typeof filters] = `${
                filters[key as keyof typeof filters]
              }`
            }
          }

          return accumulator
        },
        {} as any,
      )
    }

    if (searchText) {
      filtersTransactionsParams = {
        ...filtersTransactionsParams,
        id: searchText,
      }
    }

    if (Object.keys(filtersTransactionsParams).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(filtersTransactionsParams)}`
    }

    return {
      url: `/finance/all_transaction`,
      query,
    }
  },
  target: getTransactionsDetails,
})

sample({
  clock: loadWalletsWithArchive,
  fn: () => ({}),
  target: getWalletsWithArchiveFx,
})
